interface StatusResponse<T = any> {
  statusCode: number;
  statusDetail: string;
  statusMsg: string;
  data: T | null;
}

export function isOk({ statusCode }: StatusResponse) {
  return statusCode === 200;
}

export default StatusResponse;
